/**
 * Ein zugeklappter Bereich unter dem Termin (13.10.2026) — „Was muss da sein",
 * Notizen. Zugeklappt zeigt die Kopfzeile schon das Wichtigste: wie viel offen
 * ist und die ersten Punkte. So bleibt der Termin ruhig, und trotzdem sieht man
 * auf einen Blick, worauf es ankommt.
 *
 * `standardOffen` gilt, bis man selbst auf- oder zuklappt — „Was muss da sein"
 * steht offen, solange etwas offen ist.
 */
import { useState, type ReactNode } from "react";
import "../../styles/termin.css";

type Props = {
  titel: string;
  /** Zahl rechts im Kopf, z. B. offene Punkte; 0 = keine Zahl. */
  zahl?: number;
  /** Eine leise Zeile unter dem Titel, nur im zugeklappten Zustand. */
  vorschau?: string;
  standardOffen?: boolean;
  children: ReactNode;
};

export function Klappbereich({ titel, zahl = 0, vorschau, standardOffen = false, children }: Props) {
  const [wahl, setWahl] = useState<boolean | null>(null);
  const offen = wahl ?? standardOffen;
  return (
    <section className={"tm-klapp" + (offen ? " is-offen" : "")}>
      <button type="button" className="tm-klapp-kopf" aria-expanded={offen} onClick={() => setWahl(!offen)}>
        <span className="tm-klapp-pfeil" aria-hidden="true">›</span>
        <span className="tm-klapp-text">
          <span className="tm-klapp-titel">{titel}</span>
          {!offen && vorschau && <span className="tm-klapp-vorschau">{vorschau}</span>}
        </span>
        {zahl > 0 && <span className="tm-klapp-zahl">{zahl}</span>}
      </button>
      {offen && <div className="tm-klapp-inhalt">{children}</div>}
    </section>
  );
}
